export default {
  state: {
    adminDebt: {},
  },
  mutations: {
    SET_ADMIN_DEBT(state, payload) {
      state.adminDebt = payload.debt;
    },
    UPDATE_ADMIN_DEBT(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    DELETE_ADMIN_DEBT(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    RESTORE_ADMIN_DEBT(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
  },
  actions: {
    async GET_ADMIN_DEBT({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/admin/debts/${payload}/edit`);
        commit('SET_ADMIN_DEBT', data);
      } catch (err) {
        throw err;
      }
    },
    async UPDATE_ADMIN_DEBT({ commit }, payload) {
      try {
        const { id } = payload;
        const { data } = await window.axios.put(`/admin/debts/${id}`, payload);
        commit('UPDATE_ADMIN_DEBT', data);
      } catch (err) {
        throw err;
      }
    },
    async DELETE_ADMIN_DEBT({ commit }, payload) {
      try {
        const { data } = await window.axios.delete(`/admin/debts/${payload}`);
        commit('DELETE_ADMIN_DEBT', data);
      } catch (err) {
        throw err;
      }
    },
    async RESTORE_ADMIN_DEBT({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/admin/debts/${payload}/restore`);
        commit('RESTORE_ADMIN_DEBT', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    adminDebt(state) {
      return state.adminDebt;
    },
  },
};
